import { type FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import {
  type CastillaCredentialsResponse,
  type ConnectCastillaArgs,
  type CastillaConfig
} from 'src/modules/Settings/Integrations/pages/components/integrations2.0/Castilla/utils';
import { zeusApiV1 } from 'src/store/api';

const extendedApi = zeusApiV1.injectEndpoints({
  endpoints: build => ({
    saveCastilla: build.mutation<CastillaConfig, Partial<CastillaConfig>>({
      query: args => ({
        url: '/hercules/v1/castilla/config',
        method: 'PATCH',
        params: { subsidiary: args.subsidiary },
        body: args
      }),
      invalidatesTags: ['integration']
    }),
    connectCastilla: build.mutation<CastillaCredentialsResponse, ConnectCastillaArgs>({
      queryFn: async ({ subsidiary, body }, _api, _extraOptions, baseQuery) => {
        try {
          const result = await baseQuery({
            url: '/hercules/v1/castilla/credentials',
            method: 'POST',
            params: { subsidiary },
            body
          });

          if (result.error) {
            return {
              error: {
                ...result.error,
                data: {
                  error: 'integrations.invalid credentials'
                }
              } as unknown as FetchBaseQueryError
            };
          }

          return { data: result.data as CastillaCredentialsResponse };
        } catch (error) {
          console.error('Error fetching integration URL:', error);

          return { error: error as FetchBaseQueryError };
        }
      },
      invalidatesTags: ['integration']
    })
  }),
  overrideExisting: false
});

export const { useSaveCastillaMutation, useConnectCastillaMutation } = extendedApi;
